(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Handle hover behavior for all dropdown menus (including nested)
  document.addEventListener('DOMContentLoaded', function() {
    // Handle all details elements that contain submenus
    function setupHoverForDetails(detailsElement) {
      const submenu = detailsElement.querySelector('.header__submenu');
      if (!submenu) return; // Skip if no submenu
      
      let hoverTimeout;
      
      // Open on mouseenter
      detailsElement.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        if (!detailsElement.hasAttribute('open')) {
          detailsElement.setAttribute('open', '');
        }
      });
      
      // Close on mouseleave with a small delay
      detailsElement.addEventListener('mouseleave', function(e) {
        // Check if we're moving to the submenu
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && (submenu.contains(relatedTarget) || detailsElement.contains(relatedTarget))) {
          return; // Don't close if moving to submenu
        }
        
        hoverTimeout = setTimeout(function() {
          detailsElement.removeAttribute('open');
        }, 200); // Small delay to allow moving to submenu
      });
      
      // Keep open when hovering over submenu
      submenu.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        if (!detailsElement.hasAttribute('open')) {
          detailsElement.setAttribute('open', '');
        }
      });
      
      submenu.addEventListener('mouseleave', function(e) {
        // Check if we're moving to the parent details element
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && detailsElement.contains(relatedTarget)) {
          return; // Don't close if moving back to parent
        }
        
        hoverTimeout = setTimeout(function() {
          detailsElement.removeAttribute('open');
        }, 200);
      });
    }
    
    // Setup hover for ALL menu details (both dropdown and mega menus)
    function setupHoverForAllMenus(detailsElement) {
      const submenu = detailsElement.querySelector('.header__submenu');
      const megaMenuContent = detailsElement.querySelector('.mega-menu__content--custom') || detailsElement.querySelector('.mega-menu__content');
      const summary = detailsElement.querySelector('summary');
      let hoverTimeout;
      
      // Determine which type of menu this is
      const isMegaMenu = !!megaMenuContent;
      const isDropdownMenu = !!submenu;
      
      if (!isMegaMenu && !isDropdownMenu) return; // Skip if no menu content
      
      const menuContent = isMegaMenu ? megaMenuContent : submenu;
      
      // Open on hover over summary (menu item)
      summary.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        if (!detailsElement.hasAttribute('open')) {
          detailsElement.setAttribute('open', '');
        }
      });
      
      // Keep open when hovering over menu content
      menuContent.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        if (!detailsElement.hasAttribute('open')) {
          detailsElement.setAttribute('open', '');
        }
      });
      
      // Close when mouse leaves summary (with delay to allow moving to content)
      summary.addEventListener('mouseleave', function(e) {
        const relatedTarget = e.relatedTarget;
        // Don't close if moving to menu content
        if (relatedTarget && (menuContent.contains(relatedTarget) || detailsElement.contains(relatedTarget))) {
          return;
        }
        
        hoverTimeout = setTimeout(function() {
          // Only close if mouse is not over content
          if (!menuContent.matches(':hover') && !detailsElement.matches(':hover')) {
            detailsElement.removeAttribute('open');
          }
        }, 150);
      });
      
      // Close when mouse leaves menu content
      menuContent.addEventListener('mouseleave', function(e) {
        const relatedTarget = e.relatedTarget;
        // Don't close if moving back to summary
        if (relatedTarget && (summary.contains(relatedTarget) || detailsElement.contains(relatedTarget))) {
          return;
        }
        
        hoverTimeout = setTimeout(function() {
          // Only close if mouse is not over summary or content
          if (!summary.matches(':hover') && !menuContent.matches(':hover')) {
            detailsElement.removeAttribute('open');
          }
        }, 150);
      });
      
      // Also handle mouseleave on the entire details element as fallback
      detailsElement.addEventListener('mouseleave', function(e) {
        const relatedTarget = e.relatedTarget;
        // Don't close if moving to a child element
        if (relatedTarget && detailsElement.contains(relatedTarget)) {
          return;
        }
        
        hoverTimeout = setTimeout(function() {
          detailsElement.removeAttribute('open');
        }, 200);
      });
    }
    
    // Setup hover for all top-level menu details (both dropdown and mega menus)
    const headerMenus = document.querySelectorAll('header-menu > details');
    headerMenus.forEach(setupHoverForAllMenus);
    
    // Setup hover for all nested submenu details (second-level dropdowns)
    const nestedDetails = document.querySelectorAll('.header__submenu details');
    nestedDetails.forEach(setupHoverForAllMenus);
    
    // Get header menu container
    const headerMenuContainer = document.querySelector('.header__inline-menu');
    
    // Also handle any details that might be added dynamically
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if it's a details element with any menu (dropdown or mega)
            if (node.tagName === 'DETAILS') {
              const hasSubmenu = node.querySelector('.header__submenu');
              const hasMegaMenu = node.querySelector('.mega-menu__content--custom') || node.querySelector('.mega-menu__content');
              if (hasSubmenu || hasMegaMenu) {
                setupHoverForAllMenus(node);
              }
            }
            // Check for nested details
            const nestedDetails = node.querySelectorAll ? node.querySelectorAll('details') : [];
            nestedDetails.forEach(function(details) {
              const hasSubmenu = details.querySelector('.header__submenu');
              const hasMegaMenu = details.querySelector('.mega-menu__content--custom') || details.querySelector('.mega-menu__content');
              if (hasSubmenu || hasMegaMenu) {
                setupHoverForAllMenus(details);
              }
            });
          }
        });
      });
    });
    
    // Observe the header menu container for changes
    if (headerMenuContainer) {
      observer.observe(headerMenuContainer, {
        childList: true,
        subtree: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
